import { baseUrl, handleResponse, handleError, GetHeaders } from "../common/ApiUtils";

const apiUrl = baseUrl + "pto/reports";

export function getPtoTotalsBySubaccountYtd(year, month) {
    return fetch(`${apiUrl}/PtoBalanceBySubacctYtd/${year}/${month}`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getEmpStatement(employeeId) {
    return fetch(`${apiUrl}/${employeeId}`, GetHeaders()).then(handleResponse).catch(handleError);
}